<template>
  <div>
    <Checkbox
      class="cb-card mt-10 heading-4 weight-medium"
      title='Without Employment or Other Income'
      v-model="income.isUnemployed"
      :checked="income.isUnemployed"
    >
      <ul class="body-3 weight-regular pt-5">
        
    <li>person Currently Unemployed</li>
    <li>person with no Other Source of Income</li>
  
      </ul>

      <div v-if="income.isUnemployed">
        <div class="input-box-holder" v-validate="errors" v-has-value="income.unemployedTypeEnum">
          <RadioButton v-for="(option) in unemployedTypeEnum"
            class="input-box mt-10 weight-regular body-3"
            :key="option.name$"
            :title="option.label"
            :option="option"
            :name="'unemployedType' + index"
            :disabled="disableSelfPayerRadioInput(option, income)"
            v-model="income.unemployedTypeEnum"
          />
          <div class="validation-output text-left mt-5">
            <ErrorHandler class="error" :id="`V049_${index}`">
              You have not selected any of the options. To continue, please select one option.
            </ErrorHandler>
          </div>
        </div>

        <div v-if="isRegisteredAtTheLaborOffice">
          <div class="input-box-holder" v-validate="errors" v-has-value="income.receiveUnemploymentBenefit">
            <DoubleInlineRadioButton
              class="input-box mt-10"
              second-title='No'
              first-title='Yes'
              :name="'receiveUnemploymentBenefit' + index"
              v-model="income.receiveUnemploymentBenefit"
            >
              <p class="weight-regular body-3 mb-10">
                Receiving Unemployment Benefits
              </p>
            </DoubleInlineRadioButton>
            <div class="validation-output text-left mt-5">
                <ErrorHandler class="error" :id="`V149_${index}`">
                  You have not selected any of the options. To continue, please select one option.
                </ErrorHandler>
              </div>
          </div>
        </div>

        <div v-if="income.unemployedTypeEnum === enums.UnemployedTypeEnum.REGISTERED_AT_THE_LABOR_OFFICE">
          <InfoBox class="mt-10" :icon="require('@/assets/svg/sound-icon.svg')">
            <p class="m-0 pr-md-5 weight-regular body-3">
              If the policyholder has additional contributions to health insurance, choose one from the “Other Source of Income” options.
            </p>
          </InfoBox>
        </div>
      </div>
    </Checkbox>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import RadioButton from '@/components/RadioButton/RadioButton.vue';
import DoubleInlineRadioButton from '@/components/DoubleInlineRadioButton/DoubleInlineRadioButton.vue';
import enums from '@/mixins/enums';
import InfoBox from '@/components/InfoBox/InfoBox.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';

export default {
  name: 'UnemployedPackage',
  mixins: [enums],
  components: {
    DoubleInlineRadioButton, RadioButton, Checkbox, InfoBox, ErrorHandler,
  },
  props: {
    income: { type: Object, required: true },
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
    index: { type: Number, required: true },
  },
  methods: {
    disableSelfPayerRadioInput(option, income) {
      const { SELF_PAYER } = this.enums.UnemployedTypeEnum;
      return (option === SELF_PAYER && income.otherIncome) || (option === SELF_PAYER && income.isEmployee) || (option === SELF_PAYER && income.isSZCO);
    },
  },
  computed: {
    userHasOtherIncome() {
      const { isEmployee, isSZCO, otherIncome } = this.income;
      return isEmployee || isSZCO || otherIncome;
    },
    unemployedTypeEnum() {
      const { UnemployedTypeEnum } = this.enums;
      const { UnemployedTypeEnum: options } = this.enumsValues;
      return options.map((option) => {
        if (option === UnemployedTypeEnum.SELF_PAYER) {
          option.disabled = this.userHasOtherIncome;
        }

        if (this.model.locale.name$ === 'SK' && this.isFemale) {
          option.label = option.skFemale;
          return option;
        }
        return option;
      });
    },
    isRegisteredAtTheLaborOffice() {
      const { UnemployedTypeEnum } = this.enums;
      return this.income.unemployedTypeEnum === UnemployedTypeEnum.REGISTERED_AT_THE_LABOR_OFFICE;
    },
  },
  watch: {
    userHasOtherIncome(hasOtherIncome) {
      const { UnemployedTypeEnum } = this.enums;
      if (hasOtherIncome && this.income.unemployedTypeEnum === UnemployedTypeEnum.SELF_PAYER) {
        this.income.unemployedTypeEnum = null;
      }
    },
  },
};
</script>
